
(()=>{
 const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 const initVideos=()=>document.querySelectorAll('[data-elaa-motion]').forEach(root=>{
   const videos=[...root.querySelectorAll('video')], btn=root.querySelector('[data-motion-toggle]');
   if(!videos.length||!btn) return;
   const visible=()=>videos.find(v=>v.closest('.elaa-media-device') && getComputedStyle(v.closest('.elaa-media-device')).display!=='none') || videos[0];
   const sync=()=>{const video=visible();btn.setAttribute('aria-label',video.paused?'Play video':'Pause video');btn.textContent=video.paused?'▶':'Ⅱ';};
   btn.addEventListener('click',()=>{const video=visible();video.paused?video.play():video.pause();sync();});
   if(reduce){videos.forEach(v=>v.pause());} sync();
 });
 const initLetters=()=>document.querySelectorAll('[data-love-carousel]').forEach(root=>{
   const track=root.querySelector('[data-love-track]'), slides=[...root.querySelectorAll('[data-love-slide]')];
   if(!track||slides.length<1)return;
   const prev=root.querySelector('[data-love-prev]'), next=root.querySelector('[data-love-next]'), counter=root.querySelector('[data-love-counter]');
   let i=Math.max(0,Math.min(slides.length-1,Number(root.dataset.start||0))),timer=null;
   const duration=Math.max(300,Number(root.dataset.duration||800));
   track.style.setProperty('--love-speed',duration+'ms');
   const render=()=>{track.style.transform=`translate3d(${-i*100}%,0,0)`;slides.forEach((s,n)=>{s.setAttribute('aria-hidden',n===i?'false':'true');});if(counter)counter.textContent=`${i+1} / ${slides.length}`;};
   const go=n=>{i=(n+slides.length)%slides.length;render();};
   const interval=Math.max(3000,Number(root.dataset.interval||6000));
   const play=()=>{if(reduce||root.dataset.autoplay!=='true'||slides.length<2)return;stop();timer=setInterval(()=>go(i+1),interval);};
   const stop=()=>{if(timer){clearInterval(timer);timer=null;}};
   prev?.addEventListener('click',()=>{go(i-1);play();});next?.addEventListener('click',()=>{go(i+1);play();});
   root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',play);root.addEventListener('focusin',stop);root.addEventListener('focusout',play);
   document.addEventListener('visibilitychange',()=>document.hidden?stop():play());
   render();play();
 });
 const init=()=>{initVideos();initLetters();};
 document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
 document.addEventListener('shopify:section:load',init);
})();
